export interface ListData {
  entryFlag: boolean;
  status: number | string;
  project_service_OA_id: string;
  product_classification: string;
  credit_product_id: string;
  check_status: string;
  approval_monthly_lease_fee: number;
  approval_contract_month: number;
  approval_number: string;
  quantity: number;
  monthly_lease_fee: number;
  contract_month: number;
  acceptance_plan_date: string | null;
  remaining_lease_fee: number;
  comment: string;
  display_order: number;
  i_id: string;
  rev_no: number;
  related_ds_items: object;
}
export const DefaultListData: ListData = {
  'entryFlag': false,
  'status': '',
  'project_service_OA_id': '',
  'product_classification': '',
  'credit_product_id': '',
  'check_status': '',
  'approval_monthly_lease_fee': 0,
  'approval_contract_month': 0,
  'approval_number': '',
  'quantity': 0,
  'monthly_lease_fee': 0,
  'contract_month': 0,
  'acceptance_plan_date': null,
  'remaining_lease_fee': 0,
  'comment': '',
  'display_order': 0,
  'i_id': '',
  'rev_no': 1,
  'related_ds_items': {}
};
